import { Keyboard } from 'react-native';
import {
  BottomSheetContainer,
  createUseBottomSheetModal,
  KeyboardAvoiding,
  useSafeArea,
  useScreenSize,
} from '@banhala/ui-kit';
import { isIOS, isWeb } from 'shared/src/utils';
import { useCreateFolder } from '../../../queries/useCreateFolder';
import { FolderNameEditor } from '../components/FolderNameEditor';

export const useCreateFolderBottomSheet = createUseBottomSheetModal<
  { folderSno: number; folderName: string },
  void
>(({ confirm, cancel }) => {
  const { mutateAsync: createFolder } = useCreateFolder();
  const { bottom, top } = useSafeArea();
  const { height: screenHeight } = useScreenSize();

  return (
    <KeyboardAvoiding>
      <BottomSheetContainer
        onPressClose={() => {
          Keyboard.dismiss();
          cancel();
        }}
        minHeight={
          isWeb
            ? screenHeight / 3
            : isIOS
              ? (screenHeight - bottom - top) / 3
              : 0
        }
        title="새 서랍 추가"
      >
        <FolderNameEditor
          initialValue=""
          validate={value => value.length > 0}
          onSubmit={async value => {
            const {
              data: { sno },
            } = await createFolder({ title: value });
            confirm({ folderSno: sno, folderName: value });
          }}
          onClose={cancel}
        />
      </BottomSheetContainer>
    </KeyboardAvoiding>
  );
});
